import { SegmentedProps } from 'antd'
// import { getPassProducts, PassCategory, PassCategoryWithString } from '../../api/membership'
import { mixpanelEvent } from '@/lib/mixpanels/mixpanel'
import { PASSES_LANDING } from '@/settings/constant'
import { useQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { GetPassResponseData, PassProduct, getPassProducts } from 'src/api/membership'
import { Subjects, SubjectsWithString } from 'src/api/product'
//TODO 타입 정리 필요 : ticket, pass, solvookplus, solvookplus-subscription
export const usePassTab = () => {
	const router = useRouter()

	const passTabOptions: SegmentedProps['options'] = [
		{
			label: SubjectsWithString[Subjects.EN],
			value: Subjects.EN,
		},
		{
			label: SubjectsWithString[Subjects.KO],
			value: Subjects.KO,
		},
	]
	const { subject } = router.query
	const handlePassTab = (subject: Subjects) => {
		router.push({ pathname: PASSES_LANDING, query: { subject } })
		// mx-108 이용권 과목 탭 클릭시
		mixpanelEvent('Tab UI Clicked', {
			'Tab Type': 'Pass Product',
			'Tab Name': SubjectsWithString[subject],
		})
	}
	//TODO limit, offset, category 정리 필요
	const DEFAULT_CATEGORY: Subjects = Subjects.EN
	const passCategory = subject ? (subject as Subjects) : DEFAULT_CATEGORY

	const { data: passResponse } = useQuery(
		['getPassProducts', passCategory],
		() =>
			//ticket은 ticket , solvookplus는 전체조회
			getPassProducts({
				subjectCode: passCategory,
			}),
		{
			keepPreviousData: true,
		},
	)

	//엑스퍼트 이용권을 먼저 보여주기 위한 order sorting
	const groupBySubjectData: GetPassResponseData = useMemo(() => {
		if (!passResponse) return null

		const filterSubject = passResponse.data.filter(
			(group) => group.subject === SubjectsWithString[passCategory],
		)[0]

		// 상위 하위 아이템들 order값으로 order sorting
		const productsOrdering = [...filterSubject.products]
			.sort((a, b) => a.categoryOrder - b.categoryOrder)
			.map((product, idx) => {
				product.items = [...product.items].sort((a, b) => a.order - b.order)
				return product
			})

		return {
			...filterSubject,
			products: productsOrdering,
		}
	}, [passResponse])

	return {
		passTabOptions,
		handlePassTab,
		subject,
		groupBySubjectData,
		passCategory,
	}
}
